// Static content for Planet Air Adventure

// Business facts — single source of truth (used by footer, schema, SEO)
export const SITE_URL = "https://planetairadventurebhutan.com";
export const FOUNDED_YEAR = 2021;
export const LICENCE_NO = "1054563";

export const PACKAGES = [
  {
    id: "cultural",
    slug: "cultural-circuit",
    number: "01",
    title: "The Cultural Circuit",
    subtitle: "Paro · Thimphu · Punakha",
    duration: "7 nights",
    from: "USD 1,890",
    img: "https://images.unsplash.com/photo-1729180253317-93ba9cf4ceb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxiaHV0YW4lMjBtb25hc3RlcnklMjBtb3VudGFpbnxlbnwwfHx8fDE3ODQwNDE4MjB8MA&ixlib=rb-4.1.0&q=85",
    body: "A slow tour through the three sacred valleys — dzongs at dawn, hand-woven textiles, monk chants at dusk. Includes the pilgrimage to Taktsang, the Tiger's Nest.",
    tags: ["Guided", "Boutique stays", "Private vehicle"],
  },
  {
    id: "trek",
    slug: "druk-path-trek",
    number: "02",
    title: "Druk Path Trek",
    subtitle: "Paro → Thimphu · alpine",
    duration: "9 nights",
    from: "USD 2,450",
    img: "https://images.unsplash.com/photo-1645033393602-4f7623917853?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxoaW1hbGF5YSUyMHRyZWtraW5nfGVufDB8fHx8MTc4NDA0MTgyMHww&ixlib=rb-4.1.0&q=85",
    body: "Cross rhododendron forests and turquoise lakes at 4,200m. Six trekking days with fully supported camps, a local trail crew and a certified mountain guide.",
    tags: ["Moderate–hard", "Full camp support", "Small group"],
  },
  {
    id: "festival",
    slug: "tsechu-festival-journey",
    number: "03",
    title: "Tsechu Festival Journey",
    subtitle: "Paro · Bumthang",
    duration: "8 nights",
    from: "USD 2,190",
    img: "https://images.unsplash.com/photo-1667984849405-9d779b049d74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxiaHV0YW4lMjBmZXN0aXZhbHxlbnwwfHx8fDE3ODQwNDE4MTl8MA&ixlib=rb-4.1.0&q=85",
    body: "Reserved courtyard seats at the great masked-dance festivals. Time your visit to Paro Tsechu or Thimphu Tsechu with our festival specialists.",
    tags: ["Front-row seats", "Seasonal", "Cultural expert"],
  },
  {
    id: "flights",
    number: "04",
    title: "Airtickets · Drukair & Bhutan Airlines",
    subtitle: "Direct routes into Paro",
    duration: "Round-trip",
    from: "Best fare guarantee",
    img: "https://images.unsplash.com/photo-1584395631446-e41b0fc3f68d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxoaW1hbGF5YSUyMHRyZWtraW5nfGVufDB8fHx8MTc4NDA0MTgyMHww&ixlib=rb-4.1.0&q=85",
    body: "We book every route into Paro (PBH) — Delhi, Kolkata, Bangkok, Singapore, Kathmandu, Dhaka. Fare tracking, seat selection, luggage upgrades, all handled.",
    tags: ["Drukair", "Bhutan Airlines", "24h support"],
  },
];

export const PACKAGE_OPTIONS = [
  "The Cultural Circuit",
  "Druk Path Trek",
  "Tsechu Festival Journey",
  "Jomolhari Base Camp",
  "The Himalayan Honeymoon",
  "Wellness & Hot-Stone Retreat",
  "Eastern Bhutan Explorer",
  "A Glimpse of Bhutan",
  "Airtickets only",
  "Custom itinerary",
];

export const JOURNAL = [
  {
    tag: "Field Notes",
    read: "6 min read",
    title: "When to visit Bhutan — a month-by-month field guide",
    excerpt:
      "Clear skies in October, rhododendrons in April, festivals in autumn. The right month decides half of your journey.",
    img: "https://images.unsplash.com/photo-1729180253317-93ba9cf4ceb4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxiaHV0YW4lMjBtb25hc3RlcnklMjBtb3VudGFpbnxlbnwwfHx8fDE3ODQwNDE4MjB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "How to",
    read: "4 min read",
    title: "The Sustainable Development Fee — what it actually funds",
    excerpt:
      "Bhutan charges a daily SDF. Here is where it goes, and why it makes your trip more meaningful, not more expensive.",
    img: "https://images.unsplash.com/photo-1667984849405-9d779b049d74?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxiaHV0YW4lMjBmZXN0aXZhbHxlbnwwfHx8fDE3ODQwNDE4MTl8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    tag: "Trail",
    read: "8 min read",
    title: "Preparing for the Druk Path — an honest packing list",
    excerpt:
      "Nine days above the treeline. Layers, altitude, sleep systems and the small comforts that decide how well you walk.",
    img: "https://images.unsplash.com/photo-1645033393602-4f7623917853?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxoaW1hbGF5YSUyMHRyZWtraW5nfGVufDB8fHx8MTc4NDA0MTgyMHww&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "Do I need a visa to enter Bhutan?",
    a: "Yes — every visitor (except Indian, Bangladeshi and Maldivian passport holders) needs a visa. Planet Air Adventure applies for it on your behalf once your itinerary is confirmed; approval typically takes 3–5 working days.",
  },
  {
    q: "What is the Sustainable Development Fee?",
    a: "Bhutan charges a daily Sustainable Development Fee of USD 100 per adult per night for most international visitors (a reduced rate valid until 31 August 2027). Children aged 6–12 pay half, children under 6 are exempt, and Indian nationals pay INR 1,200 per night. The SDF funds free healthcare, education and forest conservation for Bhutanese citizens. We include it transparently in every quote.",
  },
  {
    q: "How do I fly into Bhutan?",
    a: "Paro International Airport (PBH) is served by Drukair and Bhutan Airlines. Direct routes include Delhi, Kolkata, Bagdogra, Guwahati, Bangkok, Singapore, Kathmandu and Dhaka. We book and track your flights end-to-end.",
  },
  {
    q: "Can you customise a private itinerary?",
    a: "Absolutely — most of our travellers choose a bespoke route. Send us your interests, dates and pace, and one of our curators will draft an itinerary within 24 hours.",
  },
  {
    q: "Is Bhutan suitable for solo or family travellers?",
    a: "Yes to both. Bhutan is one of the safest countries in Asia. We tailor pacing, altitude and activities for solo travellers, couples, families with young children, and multi-generational groups.",
  },
  {
    q: "What's the best month to see a Tsechu festival?",
    a: "Paro Tsechu falls in spring (March/April) and Thimphu Tsechu in autumn (Sep/Oct). We reserve courtyard seats and time your itinerary around the exact festival calendar each year.",
  },
];

export const NAV_LINKS = [
  { id: "journeys", label: "Journeys", href: "/journeys" },
  { id: "manifesto", label: "Our Craft" },
  { id: "journal", label: "Journal", href: "/journal" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Enquire" },
];

export const TESTIMONIALS = [
  {
    quote:
      "In twelve days we never once felt like tourists. Our guide Kinley read the valleys like a book — by the time we stood beneath the Tiger's Nest, Bhutan felt less like a destination and more like a secret we'd been let in on.",
    name: "Sarah & Tom Whitfield",
    origin: "London, United Kingdom",
    journey: "The Cultural Circuit",
  },
  {
    quote:
      "The camp crew had hot tea waiting at 4,100 metres before we'd even dropped our packs. Six days on the Druk Path and not a single detail left to chance.",
    name: "Marcus Chen",
    origin: "Singapore",
    journey: "Druk Path Trek",
  },
  {
    quote:
      "They timed our entire trip around the thongdrel unfurling at dawn — a moment I will carry for the rest of my life. Flights, seats, everything handled before we asked.",
    name: "Anaya Sharma",
    origin: "New Delhi, India",
    journey: "Tsechu Festival Journey",
  },
];

export const CONTACT = {
  phone1: "+975 17904838",
  phone2: "+975 77358643",
  email: "info@planetairadventurebhutan.com",
  location: "Paro, Bhutan",
  facebook: "https://www.facebook.com/planetairbhutan/",
  instagram: "https://www.instagram.com/planetair_paro/",
};
